export default "<app-blank-header></app-blank-header>\n<ion-content>\n<router-outlet></router-outlet>\n</ion-content>\n<app-footer></app-footer>\n";